import React, { memo, useCallback, useState } from 'react';
import Link from 'next/link';
import { useRouter } from 'next/navigation';

import { ITypo } from '@/app/_components/common';
import { ChevronDown, NavActiveIcon } from '@/app/assets/Icons';
import { map } from '@/utils';
import { cn } from '@nextui-org/react';

interface IProps {
	label: string;
	href: string;
	isScrolled: boolean;
	isActive: boolean;
	hasMegaNav?: boolean;
	children?: any[];
	onOpenChange?: (open: boolean) => void;
}

const NavMobileItem: React.FC<IProps> = (props) => {
	const router = useRouter();
	const [expanded, setExpanded] = useState(false);

	const handleExpand = useCallback(() => {
		if (!props.hasMegaNav) {
			router.push(props.href);
			setExpanded((prev) => !prev);
			props.onOpenChange?.(false);
			return;
		}

		setExpanded((prev) => !prev);
	}, []);

	return (
		<li className="">
			<button
				className={cn(
					'col group relative w-full  items-center gap-1 p-3 py-4 focus:outline-none xl:px-6'
				)}
				onClick={handleExpand}
			>
				<div className="row-between gap-2">
					<ITypo
						size={16}
						title={props.label}
						className={cn(
							`group-hover:text-bittersweet lg:text-16 text-14 block whitespace-nowrap text-nowrap text-center before:block before:h-0 before:overflow-hidden before:font-semibold before:content-[attr(title)] group-hover:font-semibold `,
							{
								'text-bittersweet font-semibold':
									props.isActive,
							}
						)}
					>
						{props.label}
					</ITypo>

					{props.hasMegaNav && (
						<ChevronDown
							className={cn(
								'text-gray group-hover:text-bittersweet size-4 transition-all group-hover:-rotate-90',
								{
									'text-bittersweet -rotate-90':
										props.isActive,
								}
							)}
						/>
					)}
				</div>

				<div
					className={cn(
						'group-hover:text-bittersweet absolute -bottom-0 h-[6px] w-10 shrink-0 translate-y-2 opacity-0 transition-all group-hover:translate-y-0  group-hover:opacity-100',
						{
							'text-bittersweet translate-y-0 opacity-100':
								props.isActive,
						}
					)}
				>
					<NavActiveIcon />
				</div>
			</button>

			<div
				className={cn(
					'transition-height h-0 overflow-hidden duration-0',
					{
						'h-full': expanded,
					}
				)}
			>
				{map(props.children, (item, idx) => (
					<Link
						href={item.href}
						className={cn(
							'col group relative items-center gap-1 px-3 py-1 focus:outline-none'
						)}
						onClick={() => {
							props.onOpenChange?.(false);
						}}
						key={idx}
					>
						<div className="row-between gap-2">
							<ITypo
								size={16}
								title={item.label}
								className={cn(
									`group-hover:text-bittersweet lg:text-16 text-14 block whitespace-nowrap text-nowrap text-center before:block before:h-0 before:overflow-hidden before:font-semibold before:content-[attr(title)] group-hover:font-semibold `
								)}
							>
								{item.label}
							</ITypo>
						</div>
					</Link>
				))}
			</div>
		</li>
	);
};

export default memo(NavMobileItem);
